import { Box, BoxProps } from "./Box"

export function Summary(props: BoxProps<"summary">) {
	return (
		<Box
			as="summary"
			fontSize="lg"
			fontWeight="semibold"
			cursor="pointer"
			padding="2"
			bgColor={{ hover: "subtle" }}
			{...props}
		/>
	)
}

export function Details({
	initialOpen,
	...props
}: BoxProps<"details"> & {
	initialOpen?: boolean
}) {
	return <Box as="details" open={initialOpen} {...props} />
}

Details.Summary = Summary
